/**
 * Core
 */
import { ContextProfileUser } from "../../lib/profileContext";
import { useContext, useState } from "react";
import {
  getBirthdayInFormat,
  getDate,
  getMonths,
  getYears,
  simplyClick,
  validateAge,
} from "../../helpers/index";
import SelectGlobal from "../SelectGlobal";
import ButtonGroup from "../ButtonGroup";
import { errorEventsBirthday } from "../../constants/constans";
/**
 *Styles
 */
import "./Birthday.scss";

const Birthday = ({ setStep, step }) => {
  const { data, setData } = useContext(ContextProfileUser);
  const [errorBirthday, setErrorBirthday] = useState(null);

  const handlerSubmit = () => {
    const { status, error, errors } = validateAge(
      data.month,
      data.day,
      data.year
    );

    if (!status) {
      setErrorBirthday(error);

      let successKey = "";
      if (data.month) successKey += "M";
      if (data.day) successKey += "D";
      if (data.year) successKey += "Y";

      const eventName = errorEventsBirthday[successKey];
      if (eventName) {
        simplyClick(eventName);
      }
      if (!successKey) {
        simplyClick("err_lnd_age_nodate");
      }

      return;
    }

    if (errors.invalidDate) {
      setErrorBirthday(error);

      let successKey = "";
      if (data.month) successKey += "M";
      if (data.day) successKey += "D";
      if (data.year) successKey += "Y";

      const eventName = errorEventsBirthday[successKey];
      if (eventName) {
        simplyClick(eventName);
      }
      if (!successKey) {
        simplyClick("err_lnd_age_nodate");
      }

      return;
    }

    setData({
      ...data,
      birthday: getBirthdayInFormat(data.year, data.month, data.day),
    });
    simplyClick("cl_lnd_afm3_date_birth_next");
    setStep(step + 1);
  };

  const handlerStepBack = () => {
    simplyClick("cl_lnd_afm3_date_birth_back");

    setStep(step - 1);
  };

  const handleAddMonth = (e) => {
    simplyClick("cl_lnd_afm3_date_birth_month_choose");
    setErrorBirthday(null);
    setData({ ...data, month: e.target.value });
  };

  const handleAddDay = (e) => {
    simplyClick("cl_lnd_afm3_date_birth_day_choose");

    setErrorBirthday(null);
    setData({ ...data, day: e.target.value });
  };

  const handleAddYear = (e) => {
    simplyClick("cl_lnd_afm3_date_birth_year_choose");

    setErrorBirthday(null);
    setData({ ...data, year: e.target.value });
  };

  return (
    <div className="global__form-wrap">
      <div className="birthday__form">
        <h5 className="form__title">Your date of birth is</h5>
        <div>
          <div className="date__wrapper">
            <SelectGlobal
              dateArray={getMonths()}
              data={data?.month}
              handleChange={handleAddMonth}
              customClass={"month"}
              label={"Month"}
              errorBirthday={errorBirthday}
            />
            <SelectGlobal
              dateArray={getDate()}
              data={data?.day}
              handleChange={handleAddDay}
              customClass={"day"}
              label={"Day"}
              errorBirthday={errorBirthday}
            />
            <SelectGlobal
              dateArray={getYears()}
              data={data?.year}
              handleChange={handleAddYear}
              customClass={"year"}
              label={"Year"}
              errorBirthday={errorBirthday}
            />
          </div>
          {errorBirthday && <p className="error-text">{errorBirthday}</p>}
        </div>

        <div className="global__text">
          By proceeding, you confirm you are at least 18 years old.
        </div>
      </div>
      <ButtonGroup cbStepNext={handlerSubmit} cbStepBack={handlerStepBack} />
    </div>
  );
};
export default Birthday;
